"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const utils_1 = require("../../utils");
const CustomMapperStyles_1 = __importDefault(require("./CustomMapperStyles"));
const SearchInput_1 = __importDefault(require("../SearchInput"));
const ChoiceGroupContainer_1 = __importDefault(require("./ChoiceGroupContainer"));
const ChoiceItemsContainer_1 = __importDefault(require("./ChoiceItemsContainer"));
const utils_2 = require("./utils");
const CustomMapper = (props) => {
    const [query, setQuery] = react_1.useState('');
    const onResetQuery = () => setQuery('');
    const sanitizedQuery = query && query.trim().toLowerCase();
    const filterByQuery = utils_2.createQueryFilter(sanitizedQuery);
    const searchResults = lodash_1.flatMap(props.choiceGroups, ({ items = [] }) => items.filter(filterByQuery));
    const isSearching = !lodash_1.isEmpty(sanitizedQuery);
    const [showAllGroupId, setShowAllGroupId] = react_1.useState(null);
    const searchRef = react_1.useRef(null);
    const onShowAllOptions = (groupId) => {
        if (searchRef.current) {
            searchRef.current.focus();
        }
        setShowAllGroupId(groupId);
    };
    const onSelect = (selected, item) => {
        props.onSelect(utils_1.formatFieldMappingTag(selected), item);
    };
    return (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.root },
        common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.searchContainer },
            common_utils_1.isolateComponent(SearchInput_1.default, { ariaLabel: "Search all available fields", hasIcon: true, isDisabled: false, onChange: setQuery, onReset: onResetQuery, ref: searchRef, value: query })),
        common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceGroupsContainer }, isSearching ? (common_utils_1.isolateComponent(ChoiceItemsContainer_1.default, { fallback: query, items: searchResults, onSelect: onSelect, onUseFallback: props.onUseFallback })) : (props.choiceGroups.map(group => (!showAllGroupId || showAllGroupId === group.groupId) && (common_utils_1.isolateComponent(ChoiceGroupContainer_1.default, { group: group, isInitiallyOpen: props.choiceGroups.length === 1, isShowingAll: showAllGroupId === group.groupId, key: group.groupId, onSelect: onSelect, onShowGroupOptions: onShowAllOptions }))))),
        props.canAddSearchStep && (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.addSearchStepContainer },
            common_utils_1.isolateComponent(design_system_1.Button, { color: "greyAlt", isFullWidth: true, onClick: props.onAddSearchStep, size: "small", type: "button" }, "Add a search step")))));
};
exports.default = CustomMapper;
